exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app_info {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 1rem;\n  margin: 1rem;\n  -ms-flex-align: center;\n      align-items: center; }\n\nh2 {\n  margin-top: 1rem; }\n\n.no_content {\n  text-align: center; }\n\n.check_icon {\n  width: 4rem; }\n\n.app_logo_img {\n  width: 8rem; }\n\nul {\n  padding: 0; }\n\nmat-dialog-container {\n  overflow: hidden; }\n\nmat-dialog-content {\n  overflow: initial; }\n\n.other_versions_btn {\n  margin: 1.5rem 0; }\n\n.btn_close {\n  padding: 0.6rem;\n  border: 1px solid black;\n  width: 2.6rem;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content; }\n\n.list_item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 1rem;\n  gap: 1rem;\n  cursor: text; }\n\n.mat-tab-body-content {\n  min-height: 400px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/versions/versions-info-modal/versions-info-modal.component.scss
// module id = ../../../../../src/app/components/versions/versions-info-modal/versions-info-modal.component.scss
// module chunks = main